import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { space } from '@ifixit/primitives';
import { _js } from '@ifixit/localize';
import { InstantSearch } from '@ifixit/ui/components/instant-search';
import { getSearchClient, getIndexes } from 'Guide/searchClient';
import * as HeaderActions from 'Shared/Header/actions';

interface MobileSearchProps {
   displayMobileSearch: boolean;
   toggleMobileSearch: (value?: boolean) => void;
   isOnCart: boolean;
}

const SearchContainer = styled.div<{ $active: boolean }>`
   position: absolute;
   inset: 0;
   height: ${props => (props.$active ? '100%' : '0')};
   background-color: black;
   z-index: 10;
   opacity: ${props => (props.$active ? 1 : 0)};
   visibility: ${props => (props.$active ? 'visible' : 'hidden')};
   display: flex;
   align-items: center;
   transition: opacity 0.25s;
   padding-inline: ${space[4]};
`;

const SearchBox = styled.div`
   flex-grow: 1;
   margin-right: ${space[4]};
   position: relative;
`;

const MobileSearch = ({ displayMobileSearch, toggleMobileSearch, isOnCart }: MobileSearchProps) => {
   const inputRef = useRef<HTMLInputElement>(null);

   useEffect(() => {
      if (displayMobileSearch && inputRef.current) {
         inputRef.current.focus();
      }
   }, [displayMobileSearch]);

   const searchClient = getSearchClient();
   const indices = getIndexes();

   const placeholder = isOnCart ? _js('Search by device or model #') : _js('Search');

   return (
      <SearchContainer $active={displayMobileSearch}>
         <SearchBox>
            <InstantSearch
               searchClient={searchClient}
               indices={indices}
               indexFilters={App.algoliaConfig.filtersByObjectType}
               placeholder={placeholder}
               currency={App.userPreferredStoreCurrency}
               localeCode={App.userPreferredStoreLocale}
               storeCode={App.userPreferredStoreCode}
               shortcutKey="/"
               inputProps={{
                  className: 'rounded-full',
               }}
               canPopoverOpen={displayMobileSearch}
               autoFocus={displayMobileSearch}
            />
         </SearchBox>
         <div
            className="text-white text-lg font-normal cursor-pointer hover:opacity-80 transition-opacity flex items-center justify-center py-2 px-3"
            aria-label={_js('Go back')}
            onClick={() => toggleMobileSearch(false)}
            role="button"
            tabIndex={0}
         >
            {_js('Cancel')}
         </div>
      </SearchContainer>
   );
};

const mapStateToProps = (state: any) => ({
   displayMobileSearch: state.headerState.displayMobileSearch,
});

const mapDispatchToProps = {
   toggleMobileSearch: HeaderActions.toggleMobileSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileSearch);
